import type { JSX } from "react";
import { DashboardLayout } from "./dashboard";
import { useDashboardViewModel } from "./dashboard/utils";
import routes from "routes";
import { useAppContext } from "utils/hooks";
import { assertPresent } from "utils/types";

function DashboardPage(): JSX.Element {
  const { currentUser } = useAppContext();
  assertPresent(currentUser);

  const viewModel = useDashboardViewModel(currentUser.profile);

  return (
    <DashboardLayout
      accountHref={routes.internal.account}
      membershipHref={routes.internal.membership}
      viewModel={viewModel}
    />
  );
}

export default DashboardPage;
